import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Grid, Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core'


import useStyles from './styles'

export default function JobTitleSelectionStep3(props) {
    
    const classes = useStyles()
    const [selectedLevel, setSelectedLevel] = useState('')
    
    const handleSelection = (e) => {
        setSelectedLevel(e.target.value)
    }

    const handleNext = () => {
        console.log(selectedLevel)
        props.onLevelSelection(props.levels[selectedLevel.split('_')[1]])
    }

    return (
        <>
            <Grid container>
                <Grid item xs={10}>
                    <Typography gutterBottom>
                        Please choose your job level
                    </Typography>
                </Grid >
                <Grid item xs={2}>
                    <Button disabled={!selectedLevel} variant="contained" color="primary" onClick={handleNext}>
                        Next
                    </Button>
                </Grid>
            </Grid>
            
            <Box m={2} display="flex" justifyContent="center">
                <FormControl
                    component="fieldset"
                    className={classes.formControl}
                >
                    <RadioGroup
                        aria-label="choose"
                        name="choose1"
                        value={selectedLevel}
                        onChange={handleSelection}
                    >
                        {
                            props.levels.map((level, i) => 
                                (
                                    <React.Fragment key={level.id}>
                                        <FormControlLabel
                                            value={`l_${i}`}
                                            control={<Radio color="primary" />}
                                            label={`${level.title} (${level.code})`}
                                        />
                                        <Typography variant="caption" gutterBottom>
                                            {level.description}
                                        </Typography>
                                    </React.Fragment>
                                )
                            )
                        }
                    </RadioGroup>
                </FormControl>
            </Box>
        </>
    )
}

JobTitleSelectionStep3.propTypes = {
    onLevelSelection: PropTypes.func.isRequired,
    levels: PropTypes.array.isRequired,
}
